import { v4 as uuidV4 } from 'uuid';

import { QuestionType } from '~/data/surveys';

import {
  AnswerPreProcess,
  SurveyAnswer,
  SurveyQuestion,
  SurveyResponses,
} from '../../types';

export const responsesMap = (
  survey: SurveyAnswer,
  responses: AnswerPreProcess,
): SurveyResponses => {
  const getAnswer = (qs: SurveyQuestion, r: string | number[]) => {
    const { type, yesLabel, noLabel } = qs;
    if (type === QuestionType.FREE_TEXT) {
      return r || '';
    }

    if (type === QuestionType.MULTIPLE_CHOICE) {
      return r;
    }

    if (type === QuestionType.YES_NO) {
      return r === yesLabel && r !== noLabel;
    }

    return parseInt(r as string, 10);
  };

  const answers = survey.questions.map((q: SurveyQuestion) => {
    return {
      questionId: q.id,
      questionType: q.type,
      answer: getAnswer(q, responses[q.id]),
    };
  });

  return {
    responseId: uuidV4(),
    answers,
  };
};
